import HomePage from "pages/home/HomePage";

export default function HomeRoute() {
  return <HomePage />;
}
